import React from 'react';

const DesktopWarning = () => {
  return (
    <main className='bg-black w-full h-full absolute top-0 left-0 flex flex-col items-center justify-center'>
      <div
        className='w-fit p-4 px-5 mb-4 flex items-center flex-col rounded-lg bg-neutral-900 text-red-500 '
        role='alert'
      >
        <div className='flex items-center'>
          <h1 className='text-3xl mr-2 mb-2'>:(</h1>
          <h3 className='text-lg font-medium'>This is mobile application</h3>
        </div>
        <div className='text-sm mb-1'>Please open this app on mobile in order to use it.</div>
      </div>
    </main>
  );
};

export default DesktopWarning;
